import React, { useState } from "react";
import "@styles/pages/MemberZone/MyRedemptions.scss";
import { Box, Typography, Pagination } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import AccordionRow from "@components/ui/AccordionRow";
import dayjs from "dayjs";

const MyRedemptions = () => {
  const { t, i18n } = useTranslation();

  const myRedemptionList = useSelector(
    (state) => state.memberMyRedemption.myRedemptionList
  );

  const statusLabelMap = {
    0: t("member:status_pending"),
    1: t("member:status_approved"),
    "-1": t("member:status_rejected"),
  };

  const itemsPerPage = 10;
  const [page, setPage] = useState(1);
  const totalPages = Math.ceil(myRedemptionList.length / itemsPerPage);

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const paginatedData = myRedemptionList.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  return (
    <Box className="my-redemptions-container">
      <Typography className="title">
        <Trans i18nKey="member:my_redemptions" />
      </Typography>
      {paginatedData.length === 0 && (
        <Typography className="no-data-container">
          <Trans i18nKey="member:no_redemption_found" />
        </Typography>
      )}
      {paginatedData.map((item, index) => (
        <AccordionRow
          key={index}
          summaryTitle={t("member:gift_name")}
          summaryValue={
            i18n.language === "hk_en" ? item.gift_name_hk_en : item.gift_name_hk
          }
          summaryRight={`${item.point_used.toLocaleString()} S dollar`}
          details={[
            { label: t("member:quantity"), value: item.quantity },
            {
              label: t("member:redeem_date"),
              value: dayjs(item.redeem_date).format("YYYY-MM-DD"),
            },
          ]}
        />
      ))}

      {totalPages > 1 && (
        <Box display="flex" justifyContent="center" mt={3}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={handleChangePage}
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};

export default MyRedemptions;
